import warningMana from './warningMana'

const zhCN = { warningMana: warningMana.zhCN }
const enUS = { warningMana: warningMana.enUS }
export default { zhCN, enUS }